import {
  INITIAL_STATE_PASSENGER_ZARPE,
  REQUEST_FETCH_PASSENGERS_ZARPE,
  FETCH_PASSENGERS_ZARPE_SUCCESS,
  FETCH_PASSENGERS_ZARPE_ERROR,
} from "../../../actions/reservations/passenger/fetchPassengersZarpe";

const initialState = {
  passengers: [],
  processing: false,
  fetching: false,
  message: "",
  error: "",
};

const passengerZarpeReducer = (state = initialState, action) => {
  switch (action.type) {
    case INITIAL_STATE_PASSENGER_ZARPE: {
      return {
        ...state,
        passengers: [],
        processing: false,
        fetching: false,
        message: "",
        error: "",
      };
    }
    case REQUEST_FETCH_PASSENGERS_ZARPE: {
      return {
        ...state,
        passengers: [],
        processing: false,
        fetching: true,
        message: "",
        error: "",
      };
    }
    case FETCH_PASSENGERS_ZARPE_SUCCESS: {
      return {
        ...state,
        passengers: action.passengers,
        processing: false,
        fetching: false,
        message: action.message,
        error: "",
      };
    }
    case FETCH_PASSENGERS_ZARPE_ERROR: {
      return {
        ...state,
        passengers: [],
        processing: false,
        fetching: false,
        message: "",
        error: action.error,
      };
    }
    default: {
      return state;
    }
  }
};
export default passengerZarpeReducer;
